import(/* webpackMode: "eager" */ "/app/app/[locale]/products/citadel/course/layout.tsx");
